import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Chart from 'react-google-charts';
import { Button } from 'antd';
import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

const height = window.innerHeight * .75;

class ChartUI extends Component {

    constructor(props) {
        super(props);
        this.store = this.props.store;
    }

    updateShowTransactions = () => {
        this.store.updateShowTransactions(); 
    }
    render() {
        return (
            <div>
                <PageHeader style={{ }} 
                    title={pageSectionTitle(this.store.selectedReferrer)}
                    extra = {
                        <Button onClick={() => {this.updateShowTransactions()}}> 
                            ShowTransactions 
                        </Button>}>
                    <Chart data={this.store.chartData} 
                            style = {{marginTop:'5px'}} 
                            width= "100%"
                            height={height}
                            chartType="LineChart"
                            options={this.store.TrendOptions}/>
                </PageHeader>
            </div>
        )
    }
}

export default observer(ChartUI)
